import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { fetchEntitySuccess } from 'modules/entity/actions';
import { closeInterventionUpdateModal } from 'modules/works/actions';

import * as actionTypes from '../../actionTypes';

/** @typedef {import('modules/works/types').SocketData} InterventionUpdateModalDataState */

/** @type {InterventionUpdateModalDataState} */
const initialState = null;

const set = (_, { payload }) => payload;

const reset = () => null;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.OPEN_INTERVENTION_UPDATE_MODAL, set)
    .addMatcher(isAnyOf(closeInterventionUpdateModal.match, fetchEntitySuccess.match), reset);
});
